import {Router} from 'ninelines-router';
import {showMain, showTest, showResult, goFromTestToResult, goFromResultToTest, goFromResultToMain, goFromResultToResult, showArticle, goFromArticleToTest, goFromArticleToMain, goFromResultToArticle, goFromTestToMain, goFromArticleToResult, goFromArticleToArticle, goFromTestToArticle, showMobileArticle, pageTransition, goFromMainToArticle} from './animations';
import vars from './vars';

let router = new Router();

history.scrollRestoration = 'manual';

router.addRoute({
	path: '/',
	name: 'home',
	onEnter(prevState) {
		if (prevState.route === null) {
			return showMain();
		} else if (prevState.route.path === '/test' && !vars.changeAnimationPage && !vars.changePageTest && innerWidth > 1024) {
			vars.changeAnimationPage = true;
			vars.$siteContainer.mCustomScrollbar('scrollTo', 'top');
			setTimeout(() => {
				vars.changeAnimationPage = false;
			}, 500);
		} else if (prevState.route.name === 'result') {
			return goFromResultToMain();
		} else if (prevState.route.name === 'article') {
			return goFromArticleToMain();
		} else if (prevState.route.path === '/test' && innerWidth <= 1024) {
			return goFromTestToMain();
		}

		return true;
	},
});

router.addRoute({
	path: '/test',
	name: 'test',
	onEnter(prevState) {
		if (prevState.route === null) {
			return showTest(true);
		} else if (prevState.route.path === '/' && !vars.changeAnimationPage && !vars.changePageTest) {
			vars.changeAnimationPage = true;
			vars.$siteContainer.mCustomScrollbar('scrollTo', $('.mCSB_container').height() - innerHeight);
			setTimeout(() => {
				vars.changeAnimationPage = false;
			}, 500);
		} else if (prevState.route.name === 'result') {
			return goFromResultToTest();
		} else if (prevState.route.name === 'article') {
			return goFromArticleToTest();
		}

		return true;
	},
});

router.addRoute({
	path: '/result/:id',
	name: 'result',
	onEnter(prevState, currentState) {
		let id = currentState.params.id;

		if (prevState.route === null) {
			return showResult(id, false);
		} else if (prevState.route.name === 'result') {
			return goFromResultToResult(id);
		} else if (prevState.route.name === 'test') {
			return goFromTestToResult(id, true);
		} else if (prevState.route.name === 'article') {
			return goFromArticleToResult(id);
		}

		return true;
	},
});

router.addRoute({
	path: '/article/:id',
	name: 'article',
	onEnter(prevState, currentState) {
		let id = currentState.params.id;

		if (innerWidth > 1024) {
			if (prevState.route === null) {
				return showArticle(id);
			} else if (prevState.route.name === 'result') {
				return goFromResultToArticle(id);
			} else if (prevState.route.name === 'article') {
				return goFromArticleToArticle(id);
			} else if (prevState.route.name === 'test') {
				return goFromTestToArticle(id);
			} else if (prevState.route.name === 'home') {
				return goFromMainToArticle(id);
			}
		} else {
			if (prevState.route === null) {
				return showMobileArticle(id);
			}

			return pageTransition(showMobileArticle, id);
		}

		return true;
	},
});

router.on('notFound', () => {
	document.location = '/';
});

router.start();

export {
	router,
};
